import React, { useState, useEffect } from 'react'
import { Field } from 'redux-form'
import { renderTextField } from '../../../Forms/fieldRenderers'
import { required } from '../../..//Forms/fieldValidators'
import { Col, Row, CardColumns, Card } from 'react-bootstrap'
import { FormControlLabel } from '@material-ui/core'
import Switch from '@material-ui/core/Switch'

import CupoInfo from '../CupoInfo'
import { COLORES } from '../../../../config/colores'
import MailOutlineIcon from '@material-ui/icons/MailOutline'

export function RenominacionDeCuposDialogView (props) {
  const { currentCupo } = props
  const [notificarCorredor, setNotificarCorredor] = useState(false)
  const [notificarCargador, setNotificarCargador] = useState(false)
  const [correoCargador, setCorreoCargador] = useState(null)
  const [correoCorredor, setCorreoCorredor] = useState(null)

  const fields = ['fechaDeEmisionDate', 'cereal', 'exportador', 'cargador', 'corredor']

  useEffect(() => {
    setNotificarCorredor(true)
    props.buscarCorreoCuitCorredor(currentCupo.cuitCorredor).then((result) => {
      if (result) setCorreoCorredor(result.correoElectronico)
    })
    setNotificarCargador(true)
    props.buscarCorreoCuitCargador(currentCupo.cuitCargador).then((result) => {
      if (result) setCorreoCargador(result.correoElectronico)
    })
  }, [setNotificarCorredor, setNotificarCargador, props.buscarCorreoCuitCorredor, props.buscarCorreoCuitCargador,
    setCorreoCorredor, setCorreoCargador, currentCupo])

  const handleNotificarCorredor = () => {
    if (notificarCorredor) {
      setNotificarCorredor(false)
      setCorreoCorredor(null)
      props.resetCorreoCorredor()
    } else {
      setNotificarCorredor(true)
      props.buscarCorreoCuitCorredor(currentCupo.cuitCorredor).then((result) => {
        if (result) setCorreoCorredor(result.correoElectronico)
      })
    }
  }

  const handleNotificarCargador = async () => {
    if (notificarCargador) {
      setNotificarCargador(false)
      setCorreoCargador(null)
      props.resetCorreoCargador()
    } else {
      setNotificarCargador(true)
      props.buscarCorreoCuitCargador(currentCupo.cuitCargador).then((result) => {
        if (result) {
          setCorreoCargador(result.correoElectronico)
        } else {
          setNotificarCargador(false)
          props.resetCorreoCargador()
        }
      })
    }
  }

  return (
    <>
      <Row>
        <Col md={6} className='modificacion-dialog'>
          <Row>
            <CardColumns>
              <Card className='shadow bg-secondary rounded'>
                <Card.Body>
                  <Card.Title style={{ fontSize: '1.3rem', textAlign: 'center', color: 'white' }}><b>{currentCupo.cantidadAsignada}</b></Card.Title>
                  <Card.Text style={{ textAlign: 'center', color: 'white' }}>
                    Nominados
                  </Card.Text>
                </Card.Body>
              </Card>
              <Card className='shadow bg-secondary rounded'>
                <Card.Body>
                  <Card.Title style={{ fontSize: '1.3rem', textAlign: 'center', color: 'white' }}><b>{currentCupo.cantidadDisponible}</b></Card.Title>
                  <Card.Text style={{ textAlign: 'center', color: 'white' }}>
                    Editables
                  </Card.Text>
                </Card.Body>
              </Card>
              <Card className='shadow bg-secondary rounded'>
                <Card.Body>
                  <Card.Title style={{ fontSize: '1.3rem', textAlign: 'center', color: 'white' }}><b>{currentCupo.cantidadNominableAsignado - currentCupo.cantidadAsignada}</b></Card.Title>
                  <Card.Text style={{ textAlign: 'center', color: 'white' }}>
                    Utilizables
                  </Card.Text>
                </Card.Body>
              </Card>
            </CardColumns>
          </Row>
          <Row>
            <Field
              name='cantidadRenominada'
              label='Total a nominar'
              type='number'
              component={renderTextField}
              validate={[required]}
              placeholder={currentCupo.cantidadAsignada}
            />
            {/* <div style={{ textAlign: 'left', fontSize: '0.9rem', color: COLORES.grey.dark, display: 'flex', flexDirection: 'row' }}>
                Cantidad Nominada:{' '}
              <p style={{ fontSize: '1.0rem', fontWeight: 'bold', marginLeft: '10px' }}>
                {currentCupo.cantidadAsignada}
              </p>
            </div>
            <Tooltip title={'Cantidad de cupos que se encuentran en condiciones de ser renominados'}>
              <div style={{ textAlign: 'left', fontSize: '0.9rem', color: COLORES.grey.dark, display: 'flex', flexDirection: 'row' }}>
                Total Renominable:{' '}
                <p style={{ fontSize: '1.0rem', fontWeight: 'bold', marginLeft: '10px' }}>
                  {currentCupo.cantidadDisponible}
                </p>
              </div>
            </Tooltip>
            <Tooltip title={'Cupos asignados y que se encuentran en condiciones de ser utilizados en la renominación'}>
              <div style={{ textAlign: 'left', fontSize: '0.9rem', color: COLORES.grey.dark, display: 'flex', flexDirection: 'row' }}>
                  Disponible sin Nominar:{' '}
                <p style={{ fontSize: '1.0rem', fontWeight: 'bold', marginLeft: '10px' }}>
                  {currentCupo.cantidadNominableAsignado - currentCupo.cantidadAsignada}
                </p>
              </div>
            </Tooltip> */}
          </Row>
        </Col>
        <Col md={6}>
          <CupoInfo cupo={currentCupo} fields={fields} />
        </Col>
      </Row>
      <Row>
        <Col md={4}>
          {currentCupo.cargador && <FormControlLabel style={{ marginLeft: '2%' }} control={<Switch
            color='primary'
            name='notificarCargador'
            onChange={handleNotificarCargador}
            checked={notificarCargador}
          />}label='Notificar al Cargador' />}
        </Col>
        <Col md={8}>
          {currentCupo.cargador && <h6 style={{ textAlign: 'left', marginTop: '8px', color: COLORES.grey.mediumDark }}>
            <MailOutlineIcon style={{ marginRight: '2%', color: COLORES.grey.mediumDark }} />
            {correoCargador}
          </h6>}
        </Col>
      </Row>
      <Row>
        <Col md={4}>
          {currentCupo.corredor && <FormControlLabel style={{ marginLeft: '2%' }} control={<Switch
            color='primary'
            name='notificarCorredor'
            onChange={handleNotificarCorredor}
            checked={notificarCorredor}
          />}label='Notificar al Corredor' />}
        </Col>
        <Col md={8}>
          {currentCupo.corredor && <h6 style={{ textAlign: 'left', marginTop: '8px', color: COLORES.grey.mediumDark }}>
            <MailOutlineIcon style={{ marginRight: '2%', color: COLORES.grey.mediumDark }} />
            {correoCorredor}
          </h6>}
        </Col>
      </Row>
    </>
  )
}
